<greco-alert
  *ngFor="let alert of alerts$ | async"
  style="display: block; margin-bottom: 8px"
  [config]="alert"
></greco-alert>
